//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';

var now = moment();

export default {
    data: function data() {
        return {
            user: {},
            units: [],
            unit: {},
            error: false,
            success: false,
            loading: false,
            youAintEighteen: false,
            selectedProperty: null,
            propertyName: 'Madera Properties',
            moveInMonth: null,
            moveInDay: null,
            moveInYear: null,
            occupantsAmt: null,
            hasPets: false,
            hasBedrooms: false,
            checked: false,
            occupantCount: 0,
            youngOccupantCount: 0,
            occupants: [{
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                contact_preference: ''
            }, {
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                contact_preference: ''
            }, {
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                contact_preference: ''
            }],
            youngOccupants: [{
                first_name: '',
                last_name: '',
                dobMonth: null,
                dobDay: null,
                dobYear: null
            }, {
                first_name: '',
                last_name: '',
                dobMonth: null,
                dobDay: null,
                dobYear: null
            }, {
                first_name: '',
                last_name: '',
                dobMonth: null,
                dobDay: null,
                dobYear: null
            }],
            pets: [{
                type: '',
                breed: '',
                service: false,
                allowed: false
            }],
            properties: [],
            contactPreferences: ['sms', 'email', 'phone', 'mail'],
            states: ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'],
            sources: ['Drive by', 'Resident referral', 'Former resident referral', 'Employee referral', 'Other word of mouth', 'Other Community referral', 'Google', 'Property website', 'Zillow', 'Trulia', 'Costar', 'Rentpath', 'Craigslist', 'Facebook Marketplace', 'Apartment Locator service', 'Flyer, Radio, Newspaper advertisement'],
            step: 0,
            bedroomsSelect: [{
                label: 'Studio',
                value: 0
            }, {
                label: '1',
                value: 1
            }, {
                label: '2',
                value: 2
            }, {
                label: '3',
                value: 3
            }],
            occupantsSelect: [{
                label: '0',
                value: 0
            }, {
                label: '1',
                value: 1
            }, {
                label: '2',
                value: 2
            }, {
                label: '3',
                value: 3
            }],
            emailValid: false,
            guestCardValidations: [{ model: 'unit.id', rules: 'required | integer | min:1' }]
        };
    },

    computed: {
        formatted_dob: function formatted_dob() {
            return moment(this.user.dob).format("YYYY-MM-DD");
        },
        leasingAgents: function leasingAgents() {

            return this.users.map(function (u) {
                return {
                    label: '(' + u.id + ') ' + u.first_name + ' ' + u.last_name,
                    id: '' + u.id
                };
            });
        }
    },
    created: function created() {
        var _this = this;

        Event.$on('add-guest-card-new', function (prospect) {
            _this.getProperties();
            _this.getBuildings();
            _this.getUnits();
            _this.$initValidator();
            _this.addGuestCardNew(prospect);
            _this.getUsers();
        });
        Event.$on('close-full-modal', this.closeFullModel);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('add-guest-card-new');
        Event.$off('close-full-modal');
    },
    mounted: function mounted() {

        var $el = this;

        $el.youAintEighteen = false;
        $el.property_id = this.$store.state.selectedProperty;
        $el.lease_property = this.$store.state.selectedProperty;
    },


    methods: {
        getUsers: function getUsers() {
            var _this2 = this;

            axios.get('/prototype/users/all').then(function (response) {
                _this2.users = response.data;
            });
        },
        getBuildings: function getBuildings() {
            var _this3 = this;

            axios.get('/prototype/person/guest-card/selected-building').then(function (response) {
                _this3.buildings = response.data;
            });
        },
        getProperties: function getProperties() {
            var _this4 = this;

            axios.get('/prototype/get-properties').then(function (response) {
                _this4.properties = response.data;
            });
        },
        addGuestCardNew: function addGuestCardNew() {
            var prospect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var $el = this;

            if (prospect) {
                this.user = prospect;
                this.emailIsValid();
                this.youAintEighteen = false;
            }
            $el.$children[0].$data.showModal = true;
        },
        closeFullModel: function closeFullModel() {
            this.step = 0;
            this.user = {};
        },
        close: function close() {
            var $el = this;
            Event.$emit('close-full-modal');
            $el.person = {};
            Event.$emit('guest-card-dashboard-updated');
        },
        emailIsValid: function emailIsValid() {

            this.emailValid = window.validator.validEmail(this.user.email);

            return window.validator.validEmail(this.user.email);
        },
        setBedrooms: function setBedrooms(bedroom) {
            this.$set(this.user, 'bedrooms', bedroom);
            this.hasBedrooms = true;
        },
        setPreference: function setPreference(pref) {
            this.$set(this.user, 'contact_preference', pref);
        },
        setOccupantPreference: function setOccupantPreference(pref, idx) {
            this.$set(this.occupants[idx], 'contact_preference', pref);
        },
        addPet: function addPet() {
            this.pets.push({ 'type': '', 'breed': '', 'service': false, 'allowed': false });
        },
        prettyDate: function prettyDate(date) {
            var d = moment(date);

            return d.format('dddd, MMMM Do YYYY');
        },
        selectProperty: function selectProperty(id) {
            this.user.property = id;
            this.step++;
        },
        register: function register(convert) {
            var _this5 = this;

            if (convert === 'applicant') {
                this.validator.setRules(this.guestCardValidations).validate();
                if (this.validator.fails()) {
                    var msg = 'The unit field is required for applicant';
                    this.$snotify.error(msg);
                    return;
                }
            }
            console.log(this.unit);
            var self = this;

            // @TODO: Make this work well
            // if(Object.keys(this.user).length < 13) {

            //     this.error = 'All fields are required'

            //     return false

            // }

            // Parse dates
            this.user.dob = moment(this.user.dob).format('YYYY-MM-DD');

            this.user.desired_move_date = moment(this.moveInYear + '-' + this.moveInMonth + '-' + this.moveInDay).format('YYYY-MM-DD');

            if (this.user.desired_move_date === 'Invalid date') {
                delete this.user.desired_move_date;
            }
            var tempBed = this.user.bedrooms;

            this.user.bedrooms = this.user.bedrooms ? this.user.bedrooms.value : 1;

            this.user.occupants = this.occupants.slice(0, this.occupantCount);

            this.user.coapplicants = this.youngOccupants.slice(0, this.youngOccupantCount);

            this.user.pets = this.pets;

            this.user.unit_id = this.unit ? this.unit.id : '';

            this.user.nestio_unit_id = this.unit && this.unit.nestio_unit_id ? this.unit.nestio_unit_id : '';

            this.user.convert = convert;

            this.user.leasing_agent = this.leasing_agent ? this.leasing_agent.id : 0;

            this.error = false;

            this.loading = true;

            window.axios.post('/prototype/guest-cards', this.user).then(function (response) {

                self.loading = false;

                if (response.data) {

                    self.success = true;

                    _this5.unit = '';

                    self.step = 1000;

                    Event.$emit('guest-card-dashboard-updated');
                    Event.$emit('person-updated');
                    if (_this5.user.convert === 'applicant') Event.$emit('person-archive-updated');
                }
            }).catch(function (error) {

                self.loading = false;

                self.user.bedrooms = tempBed;

                self.error = "There was an error:";

                var errors = error.response.data.errors;

                for (var e in errors) {

                    if (errors.hasOwnProperty(e)) {
                        self.error += "\n" + errors[e][0];
                    }
                }
            });
        },
        processImage: function processImage(url) {
            var imageUrl = void 0;

            if (url) {

                imageUrl = process.env.MIX_MADERA_APP_URL + '/' + url;
            } else {
                imageUrl = 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/American_Apartment_Building_-_Portland_Oregon.jpg/250px-American_Apartment_Building_-_Portland_Oregon.jpg';
            }

            return imageUrl;
        },
        getUnits: function getUnits() {

            var self = this;

            axios.get('/prototype/properties/nestio-available-units').then(function (response) {
                if (response.data) {
                    self.units = response.data.filter(function (unit) {
                        return unit.status != 'Pending Approval';
                    });
                }
            });
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/guest-cards/AddGuestCardNEW.vue
// module id = Obui
// module chunks = 0 1